var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"protocol align-center-main"},[_c('p',{staticClass:"header"},[_vm._v("用户注册协议")]),_vm._v(" "),_c('Detail'),_vm._v(" "),_c('p',{staticClass:"bottom"},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.back}},[_vm._v("返回注册")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-078012d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/Protocol.vue
// module id = null
// module chunks = 